import React, { useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const NewsletterSection = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [message, setMessage] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    const trimmed = email.trim();
    if (!trimmed || !trimmed.includes("@")) {
      setStatus("error");
      setMessage("Please enter a valid email.");
      return;
    }
    setStatus("loading");
    setMessage("");
    try {
      const res = await axios.post(`${API}/newsletter/subscribe`, {
        email: trimmed,
        source: "homepage",
      });
      setStatus("success");
      setMessage(
        res.data?.already_subscribed
          ? "You're already on the list — mahalo."
          : "Welcome to the ʻohana. Check your inbox."
      );
      setEmail("");
    } catch {
      setStatus("error");
      setMessage("Something went wrong. Please try again in a moment.");
    }
  };

  return (
    <section
      id="newsletter"
      className="section-padding newsletter-section"
      data-testid="newsletter-section"
    >
      <div className="container">
        <div className="newsletter-block">
          <span className="newsletter-eyebrow">Stay in the ʻohana</span>
          <h2 className="newsletter-title">
            First to know when a new batch is ready.
          </h2>
          <p className="newsletter-lede">
            Small-batch drops, restocks, and the occasional bedtime ritual we
            can&rsquo;t keep to ourselves — direct from Waiʻanae.
          </p>
          <form
            className="newsletter-form"
            onSubmit={onSubmit}
            data-testid="newsletter-form"
          >
            <input
              type="email"
              className="newsletter-input"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={status === "loading"}
              required
              data-testid="newsletter-email-input"
              aria-label="Email address"
            />
            <button
              type="submit"
              className="newsletter-button"
              disabled={status === "loading"}
              data-testid="newsletter-submit-button"
            >
              {status === "loading" ? "Sending…" : "Subscribe"}
            </button>
          </form>
          {message ? (
            <p
              className={`newsletter-message newsletter-message-${status}`}
              data-testid="newsletter-message"
            >
              {message}
            </p>
          ) : (
            <p className="newsletter-fineprint">
              No spam, ever. Unsubscribe anytime.
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default NewsletterSection;
